export default {
  'form.required': 'erforderlich',
  'input.good': 'gut',
  //<!------ header -------!>
  'header.book': 'Flug',
  'header.upgradetobusiness': 'Zum Partner wechseln',
  'header.checkin': 'Reservieren',
  'header.manage': 'Dashboard',
  'header.login': 'Einloggen',
  'header.signup': 'Anmeldung',
  'header.dashboard': 'Dashboard',
  'header.logout': 'Abmelden',
  'header.ticket': 'Requests',
  'header.Booking': 'Buchung',
  'header.smarttripsi': 'Smart Tripsi',
  'header.smarttripord': 'Smart Tripord',
  'header.aboutus': 'Über uns',
  'header.contactus': 'Kontaktiere uns',
  //<!------ footer ------!>
  'footer.supports': 'Unsere Unterstützungen',
  'footer.onlinechat': 'Online Chat',
  'footer.customer': 'Kundendienst',
  'footer.reserve': 'Reserve Ünterstützung',
  'footer.fax': 'Fax',
  'footer.email': 'E-Mail: Support.Tripsi.com',
  'footer.services': 'Unsere Dienstleistungen',
  'footer.flight': 'Flug',
  'footer.hotel': 'Hotel',
  'footer.tour': 'Tour',
  'footer.who': 'Wer wir sind',
  'footer.aboutus': 'Über uns',
  'footer.contactus': 'Kontakt',
  'footer.members': 'Mitglieder',
  'footer.board': 'der Direktorsrat',
  'footer.history': 'Geschichte',
  'footer.privacypolicy': 'Datenschutz ',
  'footer.privacy': 'Privatsphäre',
  'footer.claim': 'Anspruch',
  'footer.rules': 'Regeln',
  'footer.subscribe': 'News abonnieren',
  'footer.copyright': 'Copyright © 2018 Tripsi Inc, Alle Rechte vorbehalten',
  'footer.tourismMagazine': 'Tourism Magazine',
  'footer.customerClub': 'Kundenclub',
  'footer.ticketGuide': 'Ticket Guide',
  'footer.english': 'Englisch',
  'footer.persian': 'Persisch',
  'footer.address': 'Die Anschrift',
  //<!------ aboutus --------!>
  'aboutus.tripsi': 'Um Tripsi',
  'aboutus.tripord': 'Um Tripord',
  'aboutus.tripsiAboutus': `Die Tolo Air Travel and Pilgrimage Service Company begann ihre Tätigkeit in der großen Tourismusbranche im Jahr 1373. Das große Team von Tolo mit mehr als 25 Mitarbeitern, einschließlich des Vertriebs in Teheran und der technischen Abteilung in Shiraz, ist stets bestrebt, den besten Service und die hochwertigste Software bereitzustellen um die aktuellen Anbieter zufrieden zu stellen. Dieses Unternehmen begann seine Tätigkeit im Bereich touristischer Dienstleistungen online unter dem Namen Tripsi im Jahr 1401. Die Politik des Tripsi-Systems basiert auf der Zufriedenheit von Kunden und Interessengruppen und der Bereitstellung überlegener und unverwechselbarer Dienstleistungen für Kunden.`,
  'aboutus.tripordAboutus':
    "A Tripord, siamo più di una semplice piattaforma di viaggi online; siamo il vostro compagno fidato nel trasformare i viaggi dei sogni in realtà indimenticabili. Fondata nel 2021, Tripord nasce da oltre vent'anni di esperienza nel settore turistico, con la visione di creare un ecosistema di viaggio senza soluzioni di continuità, innovativo e completo.",
  'aboutus.service1_tripsi':
    'Vertreter aller nationalen und internationalen Fluggesellschaften',
  'aboutus.service2_tripsi':
    'Agentur für den Verkauf von Intercity-Tickets im Ausland',
  'aboutus.service3_tripsi':
    'Agentur für den systematischen und gecharterten Verkauf von Auslandstickets',
  'aboutus.service4_tripsi':
    'Agentur für den systematischen und gecharterten Verkauf von Inlandstickets',
  'aboutus.service5_tripsi': 'Internationale Bahnticketagentur',
  'aboutus.service6_tripsi': 'Ausgabe von Startkarten aus dem Ausland (SOTO)',
  'aboutus.service7_tripsi':
    'Organisation und Vorbereitung von Tourneen im In- und Ausland',
  'aboutus.service8_tripsi': 'Abhalten von Fachseminaren und Konferenzen',
  'aboutus.service9_tripsi':
    'Erbringung von Dienstleistungen in Visaangelegenheiten und Botschaftsdiensten, einschließlich (Botschaftszeit und Passabholung)',
  'aboutus.service10_tripsi':
    'Bereitstellung von Transferdiensten für Flughafenformalitäten (CIP)',
  'aboutus.service11_tripsi': 'Hotelreservierung im ganzen Iran und der Welt',
  'aboutus.service12_tripsi':
    'Organisation von Pilgerkarawanen, Pilgerreisen und Umrah unter der Aufsicht von Hajj und Pilgerfahrt',
  'aboutus.service1_tripord':
    'Informazioni su Tripord: Rivoluzionare i viaggi, un viaggio alla volta. In Tripord, crediamo che viaggiare dovrebbe essere semplice, personalizzato e indimenticabile. La nostra missione è trasformare il modo in cui esplori il mondo, offrendo soluzioni intelligenti, esperienze curate e supporto 24/7—tutto in un’unica piattaforma. Dai soggiorni di lusso e l’ecoturismo ai tesori nascosti e ai ritiri in fattoria, ti colleghiamo ad avventure straordinarie a prezzi competitivi.',
  'aboutus.service2_tripord': 'Perché viaggiare con noi?',
  'aboutus.service3_tripord':
    '• Piattaforma Tutto-in-Uno: Voli, soggiorni, tour e altro ancora, personalizzati in base alle tue esigenze.',
  'aboutus.service4_tripord':
    '• Innovazione e Affidabilità: Tecnologia all’avanguardia, prenotazioni sicure e prezzi trasparenti.',
  'aboutus.service5_tripord':
    '• Ricompense Importanti: Guadagna e riscatta vantaggi con il nostro Tripord Loyalty Club.',
  'aboutus.service6_tripord':
    '• Supporto Dedicato: Assistenza sempre disponibile, ovunque, 365 giorni all’anno.',
  'aboutus.service7_tripord':
    '• Viaggi Sostenibili: Promuoviamo il turismo eco-friendly e l’impatto positivo sulle comunità.',
  'aboutus.service8_tripord':
    'Con competenza e passione per la scoperta, Tripord non è solo un servizio di viaggio—è il tuo partner fidato nel creare esperienze che ispirano.',
  'aboutus.service9_tripord': 'Esplora di più. Preoccupati di meno.',
  'aboutus.address':
    'Teheran, Valiasr-Straße, oberhalb von Zafaranieh, neben der Refah Bank, Nr. 3061, Etage 2, Einheit 6',
  'aboutus.company': 'Tripsi Unternehmen',
  'aboutus.iranphone': '021-22749095',
  'aboutus.canadaaddress': 'Address : 719-938 HOWS STREET, VANCOUVER',
  'aboutus.canadaphone': '001-7786828070',
  //<!------ dashboard ------!>
  'dashboard.flightDescriptionTripsi':
    'Kaufen Sie nationale und internationale Flüge von Tripsi zum besten Preis',
  'dashboard.flightDescriptionTripord':
    'Kaufen Sie nationale und internationale Flüge von Tripord zum besten Preis',
  'dashboard.overview': 'Überblick',
  'dashboard.book': 'Buchung',
  'dashboard.search': 'suchen',
  'dashboard.reserve': 'ausgegeben',
  'dashboard.staffs': 'Mitarbeiter',
  'dashboard.random': 'zufällig',
  'dashboard.stats': 'Statistiken',
  'dashboard.overalview': 'der Überblick',
  'dashboard.lastactivities': 'Letzte Aktivitäten',
  'dashboard.opportunities': 'Gelegenheiten',
  'dashboard.tickets': 'gekauft',
  'dashboard.open': 'Nachrichten',
  'dashboard.rating': 'Note',
  'dashboard.openrequest': 'offene Anfragen',
  'dashboard.showmore': 'mehr...',
  'dashboard.onlinetickets': 'Online Tickets',
  'dashboard.derik': 'Punkt',
  'dashboard.favoritetrips': 'Meine Lieblingsreisen',
  'dumm.amount_of_new_users': 'Anzahl neuer Benutzer: {amountOfUsers}',
  'dumm.display_breite': '<strong> Breite: {Breite} </ strong>',
  'dumm.display_height': '<strong> Höhe: {Höhe} </ strong>',
  //<!----- confirmation -------!>
  /**Added by p.daneshmand */
  'confirmation.reject': 'Nein',
  'confirmation.confirm': 'Ja',
  'confirmation.confirmTitle': 'Bestätigen',
};
